import { Routes } from '@angular/router';
import { permisoGuard } from '../core/auth/permiso.guard';
import { Permiso } from '../core/auth/permisos';

/** Sección a la que pertenecen estas pantallas (encabezado de la bandeja). */
const SECCION = 'Leptospira (LEP)';

/**
 * Sección de Leptospirosis, con sus dos servicios del RT-52.
 *
 * La microaglutinación (IHIMV-RT-21-LEPTO) conserva la ruta
 * `leptospira-humano` de cuando convivía con la de animales,
 * que se retiró. El panel de serovares, el corte de positividad y la raza los
 * manda el backend según la pantalla, que va por el `data` de la ruta.
 *
 * El aislamiento (IHIMV-RT-21 LEPTO 1) lleva página propia: es cultivo, informa
 * una sola muestra y su bloque de resultados es un recuadro libre.
 *
 * La auto vacuna papiloma (IHIMV-RG-LEPTO-01) también: es el recibo de los
 * biológicos entregados, en renglones libres.
 */
export const leptospirosisRoutes: Routes = [
  {
    path: 'leptospirosis/leptospira-humano',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Leptospira',
    data: {
      pantalla: 'LEPTOSPIRA_HUMANO',
      breadcrumb: SECCION,
      titulo: 'Leptospira',
      permiso: Permiso.LEPTOSPIRA_HUMANO_VER,
    },
  },
  {
    path: 'leptospirosis/leptospira-humano/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'LEPTOSPIRA_HUMANO',
      permiso: [Permiso.LEPTOSPIRA_HUMANO_RESULTADOS, Permiso.LEPTOSPIRA_HUMANO_VER],
    },
    loadComponent: () =>
      import('./pages/leptospira-resultados/leptospira-resultados.page').then(
        (m) => m.LeptospiraResultadosPage,
      ),
    title: 'SiLabVet | Informe de resultado — Leptospira',
  },
  {
    path: 'leptospirosis/aislamiento-leptospira',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Aislamiento de Leptospira',
    data: {
      pantalla: 'AISLAMIENTO_LEPTOSPIRA',
      breadcrumb: SECCION,
      titulo: 'Aislamiento de Leptospira',
      permiso: Permiso.AISLAMIENTO_LEPTOSPIRA_VER,
    },
  },
  {
    // Página propia: el cultivo no comparte la hoja de la microaglutinación,
    // porque informa en un recuadro libre.
    path: 'leptospirosis/aislamiento-leptospira/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'AISLAMIENTO_LEPTOSPIRA',
      permiso: [
        Permiso.AISLAMIENTO_LEPTOSPIRA_RESULTADOS,
        Permiso.AISLAMIENTO_LEPTOSPIRA_VER,
      ],
    },
    loadComponent: () =>
      import(
        './pages/aislamiento-leptospira-resultados/aislamiento-leptospira-resultados.page'
      ).then((m) => m.AislamientoLeptospiraResultadosPage),
    title: 'SiLabVet | Informe de resultado — Aislamiento de Leptospira',
  },
  {
    path: 'leptospirosis/autovacuna-papiloma',
    canActivate: [permisoGuard],
    loadComponent: () =>
      import('../shared/analisis/bandeja-diagnostico/bandeja-diagnostico.page').then(
        (m) => m.BandejaDiagnosticoPage,
      ),
    title: 'SiLabVet | Auto vacuna papiloma',
    data: {
      pantalla: 'VACUNA_PAPILOMA',
      breadcrumb: SECCION,
      titulo: 'Auto vacuna papiloma',
      permiso: Permiso.VACUNA_PAPILOMA_VER,
    },
  },
  {
    // Página propia: no informa muestras sino los biológicos entregados.
    path: 'leptospirosis/autovacuna-papiloma/:id/trabajar',
    canActivate: [permisoGuard],
    data: {
      pantalla: 'VACUNA_PAPILOMA',
      permiso: [Permiso.VACUNA_PAPILOMA_RESULTADOS, Permiso.VACUNA_PAPILOMA_VER],
    },
    loadComponent: () =>
      import('./pages/vacuna-papiloma-resultados/vacuna-papiloma-resultados.page').then(
        (m) => m.VacunaPapilomaResultadosPage,
      ),
    title: 'SiLabVet | Recibo de entrega de auto vacuna papiloma',
  },
];
